import styled from "styled-components";

import ExpandableList from "app/pages/sales-intelligence/pages/company-analysis/components/shared/ExpandableList/ExpandableList";
import CollapsibleSection from "app/pages/sales-intelligence/pages/company-analysis/components/shared/section/CollapsibleSection/CollapsibleSection";
import IntentTopicsList from "app/pages/sales-intelligence/pages/company-analysis/components/signals/IntentTopicsList/IntentTopicsList";

export const StyledCollapsibleSection = styled(CollapsibleSection)`
    padding-left: 8px;
`;

export const StyledIntentTopicsList = styled(IntentTopicsList)`
    padding-left: 4px;
`;

export const StyledExpandableList = styled(ExpandableList)`
    margin-bottom: 16px;
`;
